/**
 * Single source of truth for CMS client branding.
 * For a new client: edit this file + replace public/brand_* (and API pictures/brand_*) assets.
 */
export const brandConfig = {
  productName: 'Hermész',
  cmsShortName: 'Hermész CMS',
  documentTitle: 'Hermész CMS',
  description: 'Hermész CMS',
  loginWelcome: 'Üdvözöljük a Hermész tartalomkezelő rendszerében!',
  logoAlt: 'Hermész logo',
  appBarTitle: 'Hermész Content management system',
  colors: {
    primary: '#1A2543',
    secondary: '#425DA9',
    iconSecondary: '#5B5B5B',
    themeColor: '#1A2543',
  },
  assets: {
    logoSvg: 'brand_logo.svg',
    logoPng: 'brand_logo.png',
    logo192: 'logo192.png',
    logo512: 'logo512.png',
  },
} as const;

export type BrandConfig = typeof brandConfig;

export function brandAssetUrl(fileName: string): string {
  return `${import.meta.env.BASE_URL}${fileName}`;
}

export function applyBrandToDocument(): void {
  document.title = brandConfig.documentTitle;

  const description = document.querySelector('meta[name="description"]');
  if (description) {
    description.setAttribute('content', brandConfig.description);
  }

  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) {
    themeColor.setAttribute('content', brandConfig.colors.themeColor);
  }

  const icon = document.querySelector('link[rel="icon"]');
  if (icon) {
    icon.setAttribute('href', brandAssetUrl(brandConfig.assets.logoSvg));
    icon.setAttribute('type', 'image/svg+xml');
  }
}
